import { getTracking } from '@tellimer/ui-analytics'

const { updateUser, resetUser, updateLastLogin, trackLogin, trackSignup, trackVerified } =
  getTracking('Scriber')

export { updateUser, resetUser, updateLastLogin, trackLogin, trackSignup, trackVerified }
